import { throttle } from 'throttle-debounce';

import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

export const useOnWatchedTimeChanged = (
    onWatchedTimeChanged: (watchedTime: number) => void,
    delay = 0
) => {
    useInstanceEffect(
        (instance) =>
            instance.onWatchedTimeChange(
                delay ? throttle(delay, true, onWatchedTimeChanged) : onWatchedTimeChanged
            ),
        [onWatchedTimeChanged]
    );
};
